/* eslint-disable react-hooks/exhaustive-deps*/
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { useRuleContext } from "./context/ruleContext";
import { getInitArchivingAddress, getInitEmailFlow } from "./context/helpers";

import { TOptions } from "i18next";
import { UpdateRuleLabels } from "./context/reducers/updateRuleLabels";
import { Rule, RuleUrlParams } from "../common/types";

interface Props {
  rule: Rule;
}

export default function TargetWarningModal({ rule }: Props) {
  const { t } = useTranslation("rules");
  const history = useHistory();
  const { action }: RuleUrlParams = useParams();
  const [open, setOpen] = useState(false);
  const { dispatch } = useRuleContext();

  useEffect(() => {
    if (action !== "copy") return;

    const { name, targetType } = rule;
    const nameOptions: TOptions = { interpolation: { escapeValue: false } };
    const copyName = t("copyName", { name, ...nameOptions });
    const isOpen = ["ARCHIVING_ADDRESS", "EMAIL_FLOW"].includes(targetType);
    const updateRuleLabelsAction: UpdateRuleLabels = {
      type: "updateRuleLabels",
      payload: { type: "name", input: copyName },
    };

    dispatch(updateRuleLabelsAction);
    setOpen(isOpen);
  }, [rule]);

  const handleEdit = () => {
    const changes =
      rule.targetType === "ARCHIVING_ADDRESS"
        ? getInitArchivingAddress()
        : getInitEmailFlow(rule);

    dispatch({
      type: "updateStep",
      payload: { step: "target", changes },
    });
    setOpen(false);
  };

  return (
    <Dialog open={open}>
      <DialogTitle>
        <Typography variant="h6" paragraph>
          {t("targetWarning.title")}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {t("targetWarning.body")}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="subtitle2">
          {t(`targetWarning.section.${rule.targetType}`)}
        </Typography>
      </DialogContent>
      <DialogContent>
        <Typography variant="caption" color="textSecondary">
          {t("targetWarning.info")}
        </Typography>
      </DialogContent>

      <DialogActions style={{ marginTop: "10px" }}>
        <Button
          variant="outlined"
          color="primary"
          disableElevation
          onClick={() => history.push("/rules/list")}
        >
          {t("common:cancel")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          disableElevation
          onClick={handleEdit}
        >
          {t("common:continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
